const settings = require(`./settings/${process.env.REACT_APP_CUSTOMER || 'default'}.js`);
let items;
if (process.env.REACT_APP_USER_TYPE === 'admin'){
  if (settings.budgetConfig.type === 'free'){
    items = [
      {
        name: 'Dashboard',
        url: '/dashboard',
        icon: 'icon-speedometer'
      },
      {
        title: true,
        name: 'Admin',
        wrapper: {            // optional wrapper object
          element: '',        // required valid HTML5 element tag
          attributes: {}        // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
        },
        class: ''             // optional class names space delimited list for title item ex: "text-center"
      },
      {
        name: 'Accounts',
        url: '/accounts',
        icon: 'icon-user',
      },
      {
        name: 'Locations',
        url: '/locations',
        icon: 'icon-home',
      },
      {
        name: 'Audit Events',
        url: '/audit-events',
        icon: 'icon-event'
      },
      {
        name: 'Costs',
        url: '/costs',
        icon: 'icon-tag'
      },
      {
        title: true,
        name: 'Caterer',
        wrapper: {
          element: '',
          attributes: {},
        },
      },
      {
        name: 'Menus',
        url: '/menus',
        icon: 'icon-book-open',
      },
       {
        name: 'Menu Items',
        url: '/menuItems',
        icon: 'icon-cup'
      },
      {
        name: 'Orders',
        url: '/orders',
        icon: 'icon-note'
      },
      {
        name: 'Production Sheets',
        url: '/production',
        icon: 'icon-layers'
      }
    ]
  }
  else {
    items = [
      {
        name: 'Dashboard',
        url: '/dashboard',
        icon: 'icon-speedometer'
      },
      {
        title: true,
        name: 'Admin',
        wrapper: {            // optional wrapper object
          element: '',        // required valid HTML5 element tag
          attributes: {}        // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
        },
        class: ''             // optional class names space delimited list for title item ex: "text-center"
      },
      {
        name: 'Accounts',
        url: '/accounts',
        icon: 'icon-user',
      },
      {
        name: 'Locations',
        url: '/locations',
        icon: 'icon-home',
      },
      {
        name: 'Budgets',
        url: '/budgets',
        icon: 'icon-list'
      },
      {
        name: 'Audit Events',
        url: '/audit-events',
        icon: 'icon-event'
      },
      {
        name: 'Costs',
        url: '/costs',
        icon: 'icon-tag'
      },
      {
        title: true,
        name: 'Caterer',
        wrapper: {
          element: '',
          attributes: {},
        },
      },
      {
        name: 'Menus',
        url: '/menus',
        icon: 'icon-book-open',
      },
        {
        name: 'Menu Items',
        url: '/menuItems',
        icon: 'icon-cup'
      },
      {
        name: 'Orders',
        url: '/orders',
        icon: 'icon-note'
      },
      {
        name: 'Production Sheets',
        url: '/production',
        icon: 'icon-layers'
      }
    ]
  }
  
}
else if (process.env.REACT_APP_USER_TYPE === 'caterer'){
  items = [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer'
    },
    {
      title: true,
      name: 'Admin',
      wrapper: {            // optional wrapper object
        element: '',        // required valid HTML5 element tag
        attributes: {}        // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
      },
      class: ''             // optional class names space delimited list for title item ex: "text-center"
    },
    {
      name: 'Costs',
      url: '/costs',
      icon: 'icon-tag'
    },
    {
      title: true,
      name: 'Caterer',
      wrapper: {
        element: '',
        attributes: {},
      },
    },
    {
      name: 'Menus',
      url: '/menus',
      icon: 'icon-book-open',
    },
     {
      name: 'Menu Items',
      url: '/menuItems',
      icon: 'icon-cup'
    },
    {
      name: 'Orders',
      url: '/orders',
      icon: 'icon-note'
    },
    {
      name: 'Production Sheets',
      url: '/production',
      icon: 'icon-layers'
    }
  ]
} 
else {
  items = [
    {
      name: 'Dashboard',
      url: '/dashboard',

      icon: 'icon-speedometer'

    },
    {
      title: true,
      name: 'Menus',
      wrapper: {            // optional wrapper object
        element: '',        // required valid HTML5 element tag
        attributes: {}        // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
      },
      class: ''             // optional class names space delimited list for title item ex: "text-center"
    },
    {
      name: 'Order',
      url: '/order',
      icon: 'icon-book-open',
    },
    {
      name: 'My Orders',
      url: '/orders',
      icon: 'icon-note',
    }
  ]
}
export default {
  items
};
